import { render, staticRenderFns } from "./OrderProductionStatusLabel.vue?vue&type=template&id=f091ede8&scoped=true&"
import script from "./OrderProductionStatusLabel.vue?vue&type=script&lang=js&"
export * from "./OrderProductionStatusLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f091ede8",
  null
  
)

export default component.exports